import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  TextField,
  DialogContentText
} from "@material-ui/core";
import WrenchIcon from "@material-ui/icons/Build";

import {
  addReference,
  getMetadata,
  displayError
} from "../../actions/processActions";
import {
  clearSelectedProcess,
  selectSubmission
} from "../../actions/selectActions";
import {
  closeReferenceModal,
  openApprovalModal
} from "../../actions/modalActions";

import "../../styles/processList.scss";

class ReferenceModal extends Component {
  constructor(props) {
    super(props);
    this.state = { formData: {} };
  }

  handleClose = () => {
    if (new Date() - this.props.modalOpenTime > 1000) {
      this.props.closeReferenceModal();
      this.props.clearSelectedProcess();
    }
  };

  handleSubmit = async () => {
    const metadata = await getMetadata(this.state.formData.reference);

    if (!metadata) {
      this.props.displayError("Could not retrieve metadata for provided DOI");
      return;
    }

    this.props.addReference(this.props.selectedProcess, {
      ...this.state.formData,
      ...metadata
    });
    this.handleClose();
  };

  handleChangeFormData = (key, value) => {
    this.setState({ formData: { ...this.state.formData, [key]: value } });
  };

  render() {
    const actions = [
      <Button color="secondary" onClick={this.handleClose}>
        Cancel
      </Button>,
      <Button color="primary" keyboardfocused onClick={this.handleSubmit}>
        Submit
      </Button>
    ];

    return (
      <>
        <Dialog
          open={this.props.isOpen}
          onClose={this.handleClose}
          autoScrollBodyContent={true}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Existing References</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {this.props.isOpen && (
                <table className="processList--table">
                  <tbody>
                    <tr className="header">
                      <td>DOI</td>
                      <td>First Author</td>
                      <td>Published</td>
                      <td>Citations</td>
                    </tr>
                    {this.props.selectedProcess.references.map(reference => (
                      <tr>
                        <td>
                          {this.props.adminPassword && (
                            <WrenchIcon
                              onClick={() => {
                                this.props.closeReferenceModal();
                                this.props.openApprovalModal();
                                this.props.selectSubmission(
                                  { ...this.props.selectedProcess, reference },
                                  "reference"
                                );
                              }}
                            />
                          )}
                          <a
                            className="processList--link"
                            href={"https://doi.org/" + reference.doi}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {reference.doi}
                          </a>
                        </td>
                        <td>{reference.author}</td>
                        <td>{reference.created}</td>
                        <td>{reference.citations}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogTitle>
            {this.props.selectedProcess &&
              `Add a new reference for the ALE of ${
                this.props.selectedProcess.material
              } using ${this.props.selectedProcess.reactants[0]} and ${
                this.props.selectedProcess.reactants[1]
              }`}
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Your name (optional)"
              value={this.state.formData.contributor}
              onChange={event =>
                this.handleChangeFormData("contributor", event.target.value)
              }
            />
            <br />
            <TextField
              fullWidth
              autoFocus
              margin="dense"
              label="Reference (DOI)"
              value={this.state.formData.reference}
              onChange={event =>
                this.handleChangeFormData("reference", event.target.value)
              }
            />
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    isOpen: state.modal.referenceModalIsOpen,
    selectedProcess: state.selected.process,
    modalOpenTime: state.modal.modalOpenTime,
    adminPassword: state.admin.password
  };
}

export default connect(
  mapStateToProps,
  {
    addReference,
    clearSelectedProcess,
    closeReferenceModal,
    displayError,
    openApprovalModal,
    selectSubmission
  }
)(ReferenceModal);
